window.addEventListener('DOMContentLoaded', () => {
CookieConsent.run({
  // 默认不自动弹出横幅
  autoShow: false,
  mode: "opt-out",
  revision: 2,

  // 【新增】GUI 布局配置项
  guiOptions: {
    consentModal: {
      layout: "box",
      position: "bottom right",
    },
    // 控制偏好设置弹窗的布局
    preferencesModal: {
      layout: "box", // 'box' 表示居中弹窗 (区别于 'bar' 或侧边栏)
      equalWeightButtons: false, // 按钮不要平分宽度，根据文字自适应
      flipButtons: false, // 保持正常的 DOM 按钮顺序
    },
  },

  // 默认开启全部选项
  categories: {
    necessary: { readOnly: true, enabled: true },
    performance: { readOnly: false, enabled: true },
    functionality: { readOnly: false, enabled: true },
    targeting: { readOnly: false, enabled: true },
  },

  // UI 文本 (完全按照你的截图输入)
  language: {
    default: "en",
    translations: {
      en: {
        preferencesModal: {
          title: "Manage Consent Preferences",
          acceptAllBtn: "Accept All cookies", // 将会被渲染为 Primary 按钮 (黑)
          acceptNecessaryBtn: "Only essential Cookies", // 将会被渲染为 Primary 按钮 (黑)
          savePreferencesBtn: "Confirm My choices", // 将会被渲染为 Secondary 按钮 (白框)
          closeIconLabel: "Close modal",
          sections: [
            {
              title: "Your Privacy Choices",
              description:
                'We and our third-party partners use cookies and other tracking technologies ("cookies") to automatically collect information about your visit to our website for purposes of making the site work as you expect it to, track analytics, personalize ads, measure the success of our marketing campaigns, provide a personalized web experience, and for other activities described in our Privacy Notice.<br>Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings.<br>Under certain state privacy laws, eligible residents have the right to direct a business not to "sell" their personal information or use their personal information for targeted advertising purposes. You can exercise your right to opt-out at any time by (1) adjusting the toggles below to disable cookies and (2) submitting a request through our online webform. To learn more about your Privacy Rights, see our Privacy Notice.',
            },
            {
              title: "Strictly Necessary Cookies",
              description:
                "These cookies are essential in order to enable you to move around our website and use its features, such as accessing secure areas of our website. Without these cookies services you have asked for, like shopping baskets or e-billing, cannot be provided.These cookies enable services you have specifically asked for.",
              linkedCategory: "necessary",
            },
            {
              title: "Performance Cookies",
              description:
                "These cookies collect information about how visitors use our website, for instance which pages visitors go to most often, and if they get error messages from web pages. These cookies don’t collect information that identifies a visitor. All information these cookies collect is aggregated and therefore anonymous. It is only used to improve how our website works.These cookies collect anonymous information on the pages visited.",
              linkedCategory: "performance",
            },
            {
              title: "Functionality Cookies",
              description:
                "These cookies allow our website to remember choices you make (such as your user name, language or the region you are in) and provide enhanced, more personal features. For instance, our website may be able to provide you with localization services by storing in a cookie the region in which you are currently located. These cookies can also be used to remember changes you have made to text size, fonts and other parts of web pages that you can customise. They may also be used to provide services you have asked for such as watching a video or commenting on a blog. The information these cookies collect may be anonymised and they cannot track your browsing activity on other websites.These cookies remember choices you make to improve your experience.",
              linkedCategory: "functionality",
            },
            {
              title: "Targeting / Advertising Cookies",
              description:
                "These cookies are used to deliver adverts more relevant to you and your interests They are also used to limit the number of times you see an advertisement as well as help measure the effectiveness of the advertising campaigns. They are usually placed by advertising networks with the website operator’s permission. They remember that you have visited our website and this information is shared with other organisations such as advertisers. Quite often targeting or advertising cookies will be linked to site functionality provided by the other organisation.These cookies collect information about your browsing habits in order to make advertising relevant to you and your interests.",
              linkedCategory: "targeting", // 【关键】这里的名字必须和 categories 里新增的一致
            },
          ],
        },
      },
    },
  },
});

})